// frontend/src/reducers/analyticsReducers.js
import {
  PROFIT_ANALYSIS_REQUEST,
  PROFIT_ANALYSIS_SUCCESS,
  PROFIT_ANALYSIS_FAIL,
  SALES_TRENDS_REQUEST,
  SALES_TRENDS_SUCCESS,
  SALES_TRENDS_FAIL,
  SEASONAL_ANALYSIS_REQUEST,
  SEASONAL_ANALYSIS_SUCCESS,
  SEASONAL_ANALYSIS_FAIL,
  PRODUCT_PERFORMANCE_REQUEST,
  PRODUCT_PERFORMANCE_SUCCESS,
  PRODUCT_PERFORMANCE_FAIL,
  INVENTORY_HEALTH_REQUEST,
  INVENTORY_HEALTH_SUCCESS,
  INVENTORY_HEALTH_FAIL,
  ANALYTICS_DASHBOARD_REQUEST,
  ANALYTICS_DASHBOARD_SUCCESS,
  ANALYTICS_DASHBOARD_FAIL
} from '../constants/analyticsConstants';

export const profitAnalysisReducer = (state = { data: [] }, action) => {
  switch (action.type) {
    case PROFIT_ANALYSIS_REQUEST:
      return { ...state, loading: true };
    case PROFIT_ANALYSIS_SUCCESS:
      return { loading: false, data: action.payload };
    case PROFIT_ANALYSIS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const salesTrendsReducer = (state = { data: [] }, action) => {
  switch (action.type) {
    case SALES_TRENDS_REQUEST:
      return { ...state, loading: true };
    case SALES_TRENDS_SUCCESS:
      return { loading: false, data: action.payload };
    case SALES_TRENDS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const seasonalAnalysisReducer = (state = { monthly: [], seasonal: [] }, action) => {
  switch (action.type) {
    case SEASONAL_ANALYSIS_REQUEST:
      return { ...state, loading: true };
    case SEASONAL_ANALYSIS_SUCCESS:
      return { 
        loading: false, 
        monthly: action.payload.monthly || [],
        seasonal: action.payload.seasonal || []
      };
    case SEASONAL_ANALYSIS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const productPerformanceReducer = (state = { 
  topSelling: [], 
  mostProfitable: [], 
  turnoverAnalysis: [] 
}, action) => {
  switch (action.type) {
    case PRODUCT_PERFORMANCE_REQUEST:
      return { ...state, loading: true };
    case PRODUCT_PERFORMANCE_SUCCESS:
      return { 
        loading: false, 
        topSelling: action.payload.topSelling || [],
        mostProfitable: action.payload.mostProfitable || [],
        turnoverAnalysis: action.payload.turnoverAnalysis || []
      };
    case PRODUCT_PERFORMANCE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const inventoryHealthReducer = (state = { data: [] }, action) => {
  switch (action.type) {
    case INVENTORY_HEALTH_REQUEST:
      return { ...state, loading: true };
    case INVENTORY_HEALTH_SUCCESS:
      return { loading: false, data: action.payload };
    case INVENTORY_HEALTH_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const analyticsDashboardReducer = (state = { 
  overall: {},
  inventory: {},
  today: {}
}, action) => {
  switch (action.type) {
    case ANALYTICS_DASHBOARD_REQUEST:
      return { ...state, loading: true };
    case ANALYTICS_DASHBOARD_SUCCESS:
      return { 
        loading: false, 
        overall: action.payload.overall || {},
        inventory: action.payload.inventory || {},
        today: action.payload.today || {}
      };
    case ANALYTICS_DASHBOARD_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};